import React, { useState, useEffect, useContext } from "react";
import { ShimmerTable } from "react-shimmer-effects";
import moment from "moment";
import { Table, Button } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";


function Studentadmission({ studentid, admissionId }) {
  console.log("studentid->", studentid, "admissionId->", admissionId);
  const [admissionBody, setAdmissionBody] = useState([]);
  const navigate = useNavigate(); //navigation
  useEffect(() => {
    setAdmissionBody([]);
    fetchAdmission();
  }, [studentid, admissionId]);
  const { selectedSessionId, setSelectedSessionId, currentSessionId } = useContext(SessionContext);
  const [isCurrentSession,setIsCurrentSession] = useState();

  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log('error=>', error);
      }
    }
    init();
  }, [selectedSessionId,isCurrentSession]);

  const fetchAdmission = async () => {
    let studenId = studentid;
    if (studenId !== null) {
      try {
        console.log("student@@@@@@@@@@@@>>",studenId)
        const result = await schoolApi.fetchAdmissionByStudentId(studenId);
        console.log("result->", result);

        if (result.success) {
          const registrationidstudent = result.studentAddmision.filter(
            (item) => item.id === admissionId
          );
          const withregistrationidstudetn = result.studentAddmision.filter(
            (item) => item.id !== admissionId && item.registration_id !== null
          );
          console.log("withregistrationidstudetn->", withregistrationidstudetn);

          if (registrationidstudent.length === 0) {
            setAdmissionBody([]);
            return;
          }

          registrationidstudent[0].dateofaddmission = moment(
            registrationidstudent[0].createddate || registrationidstudent[0].dateofaddmission,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
          if (withregistrationidstudetn.length > 0) {
            registrationidstudent[0].registration_id =
              withregistrationidstudetn[0]?.registration_id;
          }

          setAdmissionBody([registrationidstudent]);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const headerAdd = [
    {
      title: "Regisration Id",
      prop: "registration_id",
      isFilterable: true,
    },
    {
      title: "Student Name",
      prop: "studentname",
      isFilterable: true,
    },
    {
      title: "Date of Admission",
      prop: "dateofaddmission",
      isFilterable: true,
    },
    {
      title: "Current Class",
      prop: "current_class",
      isFilterable: true,
    },
    {
      title: "Fee Installment Type",
      prop: "fee_master_type",
      isFilterable: true,
    },
    {
      title: "Action",
      prop: "",
      isFilterable: true,
      cell: (row) => {
        return (
          <>
            <Button
              className="btn-sm mx-2 edit-button"
              variant=""
              disabled={isCurrentSession === false?true:false}
              onClick={() => editStudentAddmision(row)}
            >
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
          </>
        );
      },
    },
  ];
  const editStudentAddmision = (row) => {
    row.student_addmission_id = row.id;
    navigate(`/studentaddmissions/${row.id}/e`, {
      state: row,
    });
  };
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {admissionBody ? (
        admissionBody.length > 0 ? (
          <DatatableWrapper body={admissionBody.flat()} headers={headerAdd}>
            <Table striped className="data-table custom-table-subject-list">
              <TableHeader />
              <TableBody />
            </Table>
            <Pagination />
          </DatatableWrapper>
        ) : (
          <div>
            <DatatableWrapper body={admissionBody.flat()} headers={headerAdd}>
              <Table striped className="data-table custom-table-subject-list">
                <TableHeader />
                <TableBody>
                  <tr>
                    <td colSpan={headerAdd.length} className="text-center">
                      No Records Found!!!
                    </td>
                  </tr>
                </TableBody>
              </Table>
              <Pagination />
            </DatatableWrapper>
          </div>
        )
      ) : (
        <ShimmerTable row={10} col={8} />
      )}
    </div>
  );
}

export default Studentadmission;
